<template>
  <el-dialog
    :title="title"
    :visible="show"
    width="820px"
    :close-on-click-modal="false"
    custom-class="form-dialog-wrap"
    @close="handleClose"
  >
    <div class="form-dialog">
      <el-form
        ref="formRef"
        v-loading="initLoading"
        :model="form"
        label-width="100px"
        :disabled="mode === 'VIEW'"
      >
        <!-- 统一用户选择 -->
        <el-form-item
          label="用户"
          prop="unifyUser"
          :rules="[{ required: true, message: '请选择用户' }]"
        >
          <el-select
            v-model="form.unifyUser"
            value-key="userId"
            style="width: 100%"
            clearable
            filterable
            remote
            :remote-method="fetchUnifyUserListData"
            :disabled="mode === 'EDIT'"
            placeholder="请输入用户手机号查询"
            :loading="userSearchLoading"
          >
            <el-option
              v-for="(item) in unifyUserList"
              :key="item.name"
              :label="item.name"
              :value="item"
            />
          </el-select>
        </el-form-item>

        <!-- 受限的系统 -->
        <el-form-item
          label="管理系统"
          prop="controlSystem"
        >
          <el-select
            v-model="form.controlSystem"
            style="width: 100%"
            clearable
            filterable
            multiple
          >
            <el-option disabled value="default_option">
              <div style="text-align: right; position: relative; right: -24px;">
                <el-button type="text" @click="handleSwitchSelectAll(true)">
                  全选
                </el-button>
                <el-button
                  type="text"
                  :disabled="form.controlSystem && !form.controlSystem.length"
                  @click="handleSwitchSelectAll(false)"
                >
                  取消所有
                </el-button>
              </div>
            </el-option>
            <el-option
              v-for="item in systemOptions"
              :key="item.systemCode"
              :label="item.name"
              :value="item.systemCode"
            />
          </el-select>
        </el-form-item>

        <!-- 管控设备 -->
        <el-form-item
          label="管控设备"
          prop="controlInfos"
          :rules="[{ required: true, message: '请选择管控设备', type: 'array' }, ]"
        >
          <el-table
            :data="form.controlInfos"
            border
            max-height="300px"
          >
            <el-table-column
              prop="controlType"
              label="管控类型"
              width="120"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.id">{{ controlTypeLabel[scope.row.controlType] }}</span>
                <el-select
                  v-else
                  v-model="scope.row.controlType"
                  placeholder="请选择"
                >
                  <el-option label="设备" value="EQUIPMENT" />
                  <el-option
                    label="人脸识别"
                    value="FACE"
                    :disabled="form.controlInfos.some(item => item.controlType === 'FACE')"
                  />
                  <el-option
                    disabled
                    label="IP"
                    value="IP"
                  />
                </el-select>
              </template>
            </el-table-column>

            <el-table-column
              prop="equipmentType"
              label="设备类型"
              width="120"
            >
              <template v-if="scope.row.controlType==='EQUIPMENT'" slot-scope="scope">
                <span v-if="scope.row.id && scope.row.equipmentType">{{ handleDeviceTypeLabel(scope.row.equipmentType) }}</span>
                <el-select
                  v-else
                  v-model="scope.row.equipmentType"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in DEVICE_LIST"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </template>
            </el-table-column>

            <!-- <el-form-item
          label="设备类型"
          prop="equipmentType"
        >
          <el-select
            v-model="form.equipmentType"
            style="width: 100%"
          >
            <el-option
              v-for="item in DEVICE_LIST"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item> -->
            <el-table-column prop="controlInfo" label="管控指纹">
              <template slot-scope="scope">
                <span v-if="scope.row.id">{{ scope.row.controlInfo }}</span>
                <el-input v-else v-model="scope.row.controlInfo" />
              </template>
            </el-table-column>
            <el-table-column
              prop="availableStatus"
              label="管控状态"
              width="140"
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status === 'BIND'">
                  已激活
                </el-tag>
                <el-tag v-if="scope.row.availableStatus === 'ENABLED'">
                  生效中
                </el-tag>
                <el-tag v-if="scope.row.availableStatus === 'DISABLED'" type="danger">
                  已禁用
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="action" label="操作">
              <template slot-scope="scope">
                <div class="button-list">
                  <!-- 编辑状态 -->
                  <template v-if="mode === 'EDIT'">
                    <el-button
                      v-if="scope.row.availableStatus === 'DISABLED'"
                      type="text"
                      @click="handleChangeStatus(scope.row, 'ENABLED')"
                    >
                      启用
                    </el-button>
                    <el-button
                      v-if="scope.row.controlType!== 'FACE'"
                      type="text"
                      @click="handleChangeStatus(scope.row, 'RESTET')"
                    >
                      重置
                    </el-button>
                    <el-button
                      v-if="scope.row.availableStatus === 'ENABLED' && scope.row.controlType!== 'FACE'"
                      type="text"
                      @click="handleChangeStatus(scope.row, 'DISABLED')"
                    >
                      禁用
                    </el-button>
                    <el-popconfirm
                      v-if="!!scope.row.id"
                      title="确认移除?"
                      @confirm="handleDeleteControlInfo(scope)"
                    >
                      <el-button slot="reference" type="text">
                        移除
                      </el-button>
                    </el-popconfirm>
                    <el-button
                      v-else
                      type="text"
                      @click="handleDeleteControlInfo(scope)"
                    >
                      移除
                    </el-button>
                  </template>

                  <!-- 新增状态 -->
                  <template v-if="mode === 'ADD'">
                    <el-button
                      type="text"
                      @click="handleDeleteControlInfo(scope)"
                    >
                      移除
                    </el-button>
                  </template>

                  <!-- 查看状态 -->
                  <template v-if="mode === 'VIEW'">
                    <!-- 启用时间 -->
                    <el-form v-if="scope.row.availableStatus === 'DISABLED' && scope.row.autoEnableTime" style="display: inline-block">
                      <span style="margin-right: 5px;">启用时间：{{ formatterDateTime(scope.row.autoEnableTime) }}</span>
                    </el-form>
                    <el-form v-if="scope.row.controlType !== 'FACE'" style="display: inline-block">
                      <el-button
                        type="text"
                        @click="handleDownload(scope.row)"
                      >
                        下载
                      </el-button>
                    </el-form>
                  </template>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-button
            v-if="mode !== 'VIEW'"
            style="margin-top: 8px;"
            :disabled="form.controlInfos && form.controlInfos.length >= 20"
            @click="handleAddControlInfo"
          >
            新增
          </el-button>
        </el-form-item>
      </el-form>

      <!-- 禁用提示 -->
      <el-dialog
        width="480px"
        append-to-body
        modal-append-to-body
        custom-class="disabledDialog"
        :visible="disabledDialogVisible"
        title="禁用说明"
        @close="disabledDialogVisible = false"
      >
        <el-form
          ref="formDisabledRef"
          :model="disabledForm"
          label-width="80px"
        >
          <!-- 禁用说明 -->
          <el-form-item
            label="禁用说明"
            prop="reason"
            :rules="[{ required: true, message: '请输入禁用说明', trigger: 'blur' }]"
          >
            <el-input
              v-model="disabledForm.reason"
              maxlength="200"
              show-word-limit
              type="text"
            />
          </el-form-item>

          <!-- 启用时间 -->
          <el-form-item
            label="启用时间"
            prop="autoEnableTime"
          >
            <el-date-picker
              v-model="disabledForm.autoEnableTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
            />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="disabledDialogVisible = false">取消</el-button>
          <el-button
            type="primary"
            :disabled="disabledLoading"
            @click="handleSubmitDisable"
          >
            确定
          </el-button>
        </span>
      </el-dialog>

      <!-- 提示关跳转 -->
      <el-dialog
        width="480px"
        append-to-body
        modal-append-to-body
        custom-class="disabledDialog"
        :visible="jumpDialogVisible"
        title="提示"
        @close="handleCancelJump"
      >
        <span>该人员未在资产管理系统关联设备，请前往配置</span>
        <div>
          <a :href="jumpUrl" target="_blank">点击跳转</a>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleCancelJump">取消</el-button>
          <el-button
            type="primary"
            @click="handleCancelJump"
          >
            确定
          </el-button>
        </span>
      </el-dialog>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ mode === 'VIEW' ? '关闭' : '取消' }}</el-button>
      <el-button
        v-if="mode !== 'VIEW'"
        type="primary"
        :loading="loading"
        @click="handleSubmit"
      >
        确定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import dayjs from 'dayjs';
import {
  unifyUserIdentityAuthInfoNew,
  controlDownload, controlPage, controlStatusChange, controlUpsert, controlStatusReset,
} from '@/api/userControl';
import { v4 as uuidv4 } from 'uuid';
import { DEVICE_LIST } from '../constant';

const initForm = () => ({
  unifyUser: '',
  controlTypes: ['EQUIPMENT'],
  controlInfos: [],
  controlSystem: ['new_workbench'],
  equipmentType: 'ALLOTMENT_LAPTOP',
});

export default {
  name: 'FormDialog',
  props: {
    mode: {
      type: String,
      default: 'ADD', // 'ADD' | 'EDIT' | 'VIEW'
    },
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [Number, String],
      default: '',
    },
    systemOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tableData: [
        {
          id: 10001, name: 'Test1', role: 'Develop', sex: 'Man', age: 28, address: 'test abc',
        },
      ],
      DEVICE_LIST,
      current: {},
      loading: false,
      initLoading: false,
      form: initForm(),
      unifyUserList: [],
      userSearchLoading: false,
      // 禁用信息弹框
      disabledDialogVisible: false,
      disabledForm: {
        reason: '',
        autoEnableTime: '',
      },
      disabledLoading: false,
      jumpDialogVisible: false,
      controlTypeLabel: {
        IP: 'IP',
        EQUIPMENT: '设备',
        FACE: '人脸识别',
      },
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      if (this.mode === 'ADD') return '新增用户';
      if (this.mode === 'VIEW') return '查看用户';
      return '编辑用户';
    },
    jumpUrl() {
      if (process.env.VUE_APP_ENV === 'qa') {
        return 'https://eam.qa.yunlizhi.net/#/login';
      }
      return 'https://eam.yunlizhi.cn/#/login';
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.init();
      }
    },
  },
  methods: {
    handleDeviceTypeLabel(str) {
      return DEVICE_LIST.find((item) => item.value === str)?.label || '';
    },
    async init() {
      if (this.mode !== 'ADD' && this.current) {
        await this.fetchDetailData();
        const {
          unifyName, unifyId, mobile, details, controlSystem, controlTypes, companyId, companyName,
        } = this.current;
        const unifyUser = {
          realName: unifyName,
          userId: unifyId,
          unifyId,
          companyId,
          companyName,
          mobile,
          name: `${unifyName}(${mobile})`,
        };
        this.unifyUserList = [unifyUser];
        // eslint-disable-next-line consistent-return
        details.forEach((item) => {
          // eslint-disable-next-line no-param-reassign
          if (item.equipmentType === 'NONE' && item.controlType === 'EQUIPMENT') { item.equipmentType = null; }
        });
        this.form = {
          unifyUser,
          controlTypes,
          controlInfos: details,
          controlSystem,
        };
        console.log(this.form);
      } else {
        this.form = initForm();
        this.unifyUserList = [];
      }
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate();
      });
    },
    async fetchDetailData() {
      try {
        this.initLoading = true;
        const resp = await controlPage({
          id: this.id,
          needConfigDetail: true,
        });
        if (resp.records?.length) {
          this.current = resp.records.shift();
        }
      } finally {
        this.initLoading = false;
      }
    },
    async handleSubmit() {
      try {
        await this.$refs.formRef.validate();
        try {
          this.loading = true;
          const {
            unifyId, realName, mobile, companyId, companyName,
          } = this.form.unifyUser;
          const {
            controlTypes, controlSystem, controlInfos, equipmentType,
          } = this.form;

          const calcControlInfos = [];
          let isEquipment = false;
          let isFace = false;
          let isOk = true;
          controlInfos.forEach((item) => {
            if (item.controlType === 'EQUIPMENT') {
              if (!item.equipmentType) {
                isOk = false;
              }
              isEquipment = true;
            } else if (item.controlType === 'FACE') {
              // eslint-disable-next-line no-param-reassign
              item.equipmentType = 'NONE';
              isFace = true;
            }
            calcControlInfos.push(item);
          });
          if (!isOk) {
            this.$message.warning('请选择设备类型');
            return;
          }
          if (isEquipment) {
            controlTypes.push('EQUIPMENT');
          }
          if (isFace) {
            controlTypes.push('FACE');
          }
          const data = {
            equipmentType,
            unifyId,
            unifyName: realName,
            companyId,
            companyName,
            mobile,
            controlTypes,
            controlSystem,
            controlInfos: calcControlInfos,
            id: this.mode === 'EDIT' ? this.id : undefined,
          };

          await controlUpsert(data);
          this.$message.success('保存成功');
          this.$emit('ok');
          this.handleClose();
        } finally {
          this.loading = false;
        }
      } catch (err) {
        const error = err[Object.keys(err).shift()].shift();
        this.$message.warning(error.message);
      }
    },
    handleClose() {
      this.show = false;
    },
    async fetchUnifyUserListData(query) {
      if (query.length === 11) {
        try {
          this.userSearchLoading = true;
          const resp = await unifyUserIdentityAuthInfoNew({
            loginType: 'MOBILE',
            workPhone: query,
            userIdentity: 'TENANT',
          });

          // this.unifyUserList = [{
          //   ...user,
          //   name: `${user.realName}(${user.mobile})`,
          // }];
          this.unifyUserList = resp.map((item) => ({
            ...item, realName: item.name, mobile: item.workPhone, name: `${item.name}(${item.workPhone})`,
          }));
        } finally {
          this.userSearchLoading = false;
        }
      }
    },
    handleAddControlInfo() {
      if (this.form.controlInfos) {
        this.form.controlInfos.push({
          controlInfo: uuidv4(),
          controlType: 'EQUIPMENT',
          equipmentType: 'ALLOTMENT_LAPTOP',
        });
      }
    },
    handleDeleteControlInfo(scope) {
      this.form.controlInfos.splice(scope.$index, 1);
    },
    async handleChangeStatus(row, status) {
      if (status === 'RESTET') {
        await controlStatusReset({
          controlInfo: row.controlInfo,
        });
      } else if (status === 'DISABLED') {
        this.disabledForm.id = this.id;
        this.disabledForm.detailId = row.id;
        this.disabledForm.status = status;
        this.disabledForm.reason = '';
        this.disabledForm.autoEnableTime = '';
        this.disabledDialogVisible = true;
        return;
      } else {
        await controlStatusChange({
          id: this.id,
          detailId: row.id,
          status,
        });
      }
      this.$message.success('操作成功');
      this.init();
    },
    async handleSubmitDisable() {
      try {
        await this.$refs.formDisabledRef.validate();
        try {
          this.disabledLoading = true;
          await controlStatusChange({
            ...this.disabledForm,
          });
          this.$message.success('操作成功');
          this.disabledDialogVisible = false;
          this.init();
        } finally {
          this.disabledLoading = false;
        }
      } catch (err) {
        const error = err[Object.keys(err).shift()].shift();
        this.$message.warning(error.message);
      }
    },
    async handleDownload(row) {
      const resp = await controlDownload({ controlInfo: row.controlInfo, id: this.id });
      if (resp.url) {
        window.open(resp.url);
      }
    },
    handleSwitchSelectAll(isSelectAll = false) {
      if (isSelectAll) {
        this.form.controlSystem = this.systemOptions.map((item) => item.systemCode);
      } else {
        this.form.controlSystem = [];
      }
    },
    handleChangeControlType(typeList) {
      if (!typeList.includes('EQUIPMENT')) {
        this.form.controlInfos = [];
      }
    },
    formatterDateTime(val) {
      if (!val) return '-';
      return dayjs(val).format('YYYY-MM-DD HH:mm:ss');
    },
    handleCancelJump() {
      this.form.unifyUser = [];
      this.jumpDialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-dialog {
  width: 100%;
  max-height: 60vh;
  overflow: auto;
  padding: 24px 20px 0;
  box-sizing: border-box;

  .button-list > *:not(:first-child) {
    margin-left: 4px !important;
  }
}

.control-info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  &__left {
    display: flex;
    align-items: center;

    &>*:not(:first-child) {
      margin-left: 8px;
    }

    .index-label {
      width: 40px;
      flex: 0 0 auto
    }
  }

  .delete-icon {
    cursor: pointer;

    &:hover {
      color: red;
    }
  }

}
</style>

<style lang="scss">
  .form-dialog-wrap .el-dialog__body {
    padding: 0 !important;
  }
  .disabledDialog {
    .el-date-editor  {
      width: 100%;
    }
  }

</style>
